import { Linq as SERVICE_WORKER_Linq } from '../../../../ServiceWorker/src/helpers/linq';

export { SERVICE_WORKER_Linq as Linq };
